"use client";

import React, { useCallback, useMemo, useState } from "react";

import { Column } from "@/components/containers";
import { Image } from "@/components/displays";
import { PosaChargeConfirm, PosaChargeInput } from "@/components/domains/posa";
import { PosaChargeComplete } from "@/components/domains/posa/PosaChargeComplete";
import { useParsedGetPoints } from "@/queries/point";

type ChargeStep = "input" | "confirm" | "complete";

export function MyPagePosaChargePage(): React.ReactNode {
  const { data: points, refetch: refetchPoints } = useParsedGetPoints();
  const [posaCardNumber, setPosaCardNumber] = useState<string>("");
  const [posaCardChargePoint, setPosaCardChargePoint] = useState<number>(0);
  const [chargedSuccess, setChargedSuccess] = useState<boolean>(false);

  const chargeStep: ChargeStep = useMemo(() => {
    if (chargedSuccess) {
      return "complete";
    }
    if (posaCardNumber && posaCardChargePoint > 0) {
      return "confirm";
    }
    return "input";
  }, [posaCardNumber, posaCardChargePoint, chargedSuccess]);

  const handleChargeSuccess = useCallback(async () => {
    // チャージ成功後、ポイントを再取得
    await refetchPoints();
    // チャージ成功フラグをセット
    setChargedSuccess(true);
    // チャージ画面の入力内容をクリア
    setPosaCardNumber("");
    setPosaCardChargePoint(0);
  }, [refetchPoints]);

  return (
    <Column
      align="center"
      gap={40}
      className="w-full h-[600px] relative bg-[#fff] py-10 px-7 box-border"
    >
      <Column align="start" className="w-[216px]">
        <Image
          src="https://asset.basefood.co.jp/images/logo/logo-color.svg"
          alt="ベースフード株式会社"
          height={30}
          width={184}
        />
      </Column>
      <section className="w-full max-w-[476px] text-center text-[20px] text-[#5a5a5a]">
        {chargeStep === "input" && (
          <PosaChargeInput
            setPosaCardNumber={setPosaCardNumber}
            setPosaCardChargePoint={setPosaCardChargePoint}
          />
        )}
        {chargeStep === "confirm" && (
          <PosaChargeConfirm
            chargePoints={posaCardChargePoint}
            currentPoints={points?.total}
            posaCardNumber={posaCardNumber}
            onChargeSuccess={handleChargeSuccess}
          />
        )}
        {chargeStep === "complete" && <PosaChargeComplete currentPoints={points?.total} />}
      </section>
    </Column>
  );
}
